import React from 'react';
import './Productionproces.css';
import Manufactu from '../../../imgs/Manufactuproc.webp';

const Productionproces = () => {
    return (
        <div className="Generallyin-container">
            <div className='Cavitys'>
                <h2 className="Generallyin-title">The most common production processes are as follows:</h2>
                <p className="Generallyin-date">Plastic Pallet Injection Molding Machines: </p>
                <p className="Generallyin-tex">The machine melts the plastic material and injects 
                    them into the pallet mold, after cooling, gets the pallets with complex structures.</p>
                <p className="Generallyin-date">Plastic Pallet Thermoforming Molding Machines:</p>
                <p className="Generallyin-tex">It is about the vacuum thermoforming pallets,
                     the plastic sheet shall be heated and then drawn into the mold by a vacuum.</p>
                <p className="Generallyin-date">Plastic Pallet Blow Molding Machines:</p>
                <p className="Generallyin-tex">The plastic material tube is extruded and then blown on
                     the mold to shape the pallets. Which needs further processes as well. </p>
                <p className="Generallyin-date">Plastic Pallet Compression Molding Machines: </p>
                <p className="Generallyin-tex"> For this machine,
                     it put plastic material heated to the mold, and press them, finally get the pallets.</p>
                
                <div className="Productionp">
                    <img src={Manufactu} alt="72 Generallyin PET Preforms Machine" className="Productionp-image" />
                    <div className="Generallyin-content">

                        <p className="Generallyin-text">From what is mentioned above, you could see 
                            that when choosing the suitable plastic pallet making machine, the pallet requirements,
                             production capacity, and production cost would be considered well.</p>


                    </div>
                </div>
            </div>

        </div>
    );
};

export default Productionproces;
